import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// STYLES
import RadioContainer from './styles';

const RadioCard = ({ dataAttributes, ...props }) => {
  const {
    name,
    text,
    helpText,
    segmentText,
    value,
    imageSrc,
    checkedValue,
    handleChange,
    handleBlur,
    height,
  } = props;
  const isChecked = checkedValue === value;

  return (
    <RadioContainer
      className={clsx('radio-card noselect', isChecked && 'radio-card--checked')}
      height={height}
      {...props}
    >
      {!!imageSrc && <img className="radio-card__image" src={imageSrc} alt={text || value} />}
      {!!text && <span className="radio-card__title">{text}</span>}
      {!!helpText && <span className="radio-card__help-text p4">{helpText}</span>}
      <input
        type="radio"
        name={name}
        data-text={text || segmentText}
        checked={isChecked}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...dataAttributes}
      />
    </RadioContainer>
  );
};

RadioCard.defaultProps = {
  text: '',
  helpText: '',
  segmentText: '',
  imageSrc: '',
  checkedValue: '',
  height: 130,
  dataAttributes: {},
};

RadioCard.propTypes = {
  text: PropTypes.string,
  helpText: PropTypes.string,
  segmentText: PropTypes.string,
  checkedValue: PropTypes.string,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  imageSrc: PropTypes.string,
  height: PropTypes.number,
  dataAttributes: PropTypes.object,
};

export default React.memo(RadioCard);
